import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../hooks/use-toast';
import { isPipelineOnly } from '../lib/pipelineConsultor';
import { caminhoSeguro, consumirRetorno, guardarRetorno } from '../lib/sessao';
import CareLogo from '../components/CareLogo';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithMicrosoft, isAuthenticated, user } = useAuth();
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);

  // Guarda o destino original (ex: /minha-semana?year=2026&week=30 do link do e-mail,
  // ou a página onde a sessão expirou e o operador escolheu "Entrar de novo").
  // O loginRedirect do MSAL recarrega a página e perde o state do router,
  // então persistimos em sessionStorage para sobreviver ao redirect — só
  // caminhos da MESMA origem (lib/sessao.js).
  useEffect(() => {
    if (location.state?.from) {
      guardarRetorno(location.state.from);
    }
  }, [location.state]);

  // Se já está autenticado (ex: voltou do redirect), redireciona para o destino
  // original quando houver; senão mantém o fluxo padrão por perfil.
  useEffect(() => {
    if (isAuthenticated && user) {
      toast({
        title: 'Sucesso',
        description: `Bem-vindo, ${user.name}!`
      });
      const from = caminhoSeguro(location.state?.from) || consumirRetorno();
      navigate(from || (isPipelineOnly(user) ? '/minha-semana' : '/dashboard'));
    }
  }, [isAuthenticated, user, navigate, toast, location.state]);

  const handleMicrosoftLogin = async () => {
    setLoading(true);

    try {
      const result = await loginWithMicrosoft();

      // Se retornou resultado com erro (loginRedirect não retorna nada em caso de sucesso)
      if (result && !result.success) {
        toast({
          title: 'Erro no login',
          description: result.message || 'Não foi possível autenticar',
          variant: 'destructive'
        });
        setLoading(false);
      }
      // Se não retornou nada, o redirect está acontecendo — manter "Conectando…"
    } catch (error) {
      toast({
        title: 'Erro',
        description: 'Ocorreu um erro ao fazer login',
        variant: 'destructive'
      });
      setLoading(false);
    }
  };

  return (
    <div className="entrar" data-theme="light">
      <main className="entrar__caixa">
        {/* Marca + título */}
        <div className="entrar__lockup">
          <CareLogo justo height={33.1} className="entrar__logo" />
        </div>
        <h1 className="entrar__titulo">Painel Gerencial</h1>
        <p className="entrar__sub">Use sua conta Microsoft corporativa para acessar.</p>

        {/* Microsoft Login Button */}
        <button
          type="button"
          onClick={handleMicrosoftLogin}
          disabled={loading}
          aria-busy={loading}
          className="login-botao"
        >
          {loading ? (
            'Conectando…'
          ) : (
            <>
              <svg width="18" height="18" viewBox="0 0 21 21" fill="none" aria-hidden="true">
                <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
                <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
                <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
                <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
              </svg>
              Entrar com Microsoft
            </>
          )}
        </button>

        <p className="entrar__nota">Acesso restrito a @caremfo.com</p>
      </main>
    </div>
  );
};

export default Login;
